<!-- 支付宝支付 -->
<template>
  <div class="index">
    <div class="title">
      <span>{{ $route.name }}</span>
    </div>
    <div class="main">
      <el-form
        :inline="false"
        ref="rulesForm"
        :rules="rules"
        :model="form"
        label-width="125px"
      >
        <div class="main-title">
          <img src="@/assets/img/payCard/info.png" alt="" />
          <p>基本信息</p>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商户别名" prop="aliasName" :required="true">
              <el-input
                v-model="form.aliasName"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户类别码" prop="mcc" :required="true">
              <el-cascader
                v-model="form.mcc"
                clearable
                :options="mccOptions"
                @change="handleMcchange"
                :disabled="editDisable"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="签约支付宝账号"
              prop="bindingAlipayLogonId"
              :required="true"
            >
              <el-input
                v-model="form.bindingAlipayLogonId"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人名称" prop="name" :required="true">
              <el-input v-model="form.name" placeholder="请输入" :disabled="editDisable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商户编号" :required="true">
              <el-input
                v-model="form.externalId"
                disabled
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobile" :required="true">
              <el-input v-model="form.mobile" placeholder="请输入" :disabled="editDisable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="main-title line">
          <img src="@/assets/img/payCard/other.jpg" alt="" />
          <p>结算信息</p>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="账户名"
              prop="accountHolderName"
              :required="true"
            >
              <el-input
                v-model="form.accountHolderName"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="银行名称"
              prop="accountInstName"
              :required="true"
            >
              <el-input
                v-model="form.accountInstName"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <!-- <el-form-item label="开户行" :required="true">
              <el-input v-model="form.accountBranchName" placeholder="请输入"></el-input>
            </el-form-item> -->
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="银行缩写"
              prop="accountInstId"
              :required="true"
            >
              <el-input
                v-model="form.accountInstId"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡类型" prop="accountType" :required="true">
              <el-radio v-model="form.accountType" :disabled="editDisable" label="DC">借记卡</el-radio>
              <el-radio v-model="form.accountType" :disabled="editDisable" label="CC">信用卡</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开户行号" prop="accountNo" :required="true">
              <el-input
                v-model="form.accountNo"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="账号使用类型"
              prop="usageType"
              :required="true"
            >
              <el-radio v-model="form.usageType" :disabled="editDisable" label="01">对公</el-radio>
              <el-radio v-model="form.usageType" :disabled="editDisable" label="02">对私</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="账号" :required="true">
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="开户行所在地" :required="true">
              <el-select
                style="margin-right: 10px"
                v-model="form.bankAddressCode.proviceCode"
                @change="
                  (val) => {
                    handleProviceChange(val);
                  }
                "
                clearable
                filterable
                placeholder="请选择省"
                :disabled="editDisable"
              >
                <el-option
                  v-for="item in proviceList"
                  :key="item.area_code"
                  :label="item.area_name"
                  :value="item.area_code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-select
              style="margin-right: 10px"
              v-model="form.bankAddressCode.cityCode"
              @change="
                (val) => {
                  handleCityChange(val);
                }
              "
              clearable
              filterable
              placeholder="请选择市"
              :disabled="editDisable"
            >
              <el-option
                v-for="item in cityList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="form.bankAddressCode.areaCode"
              @change="
                (val) => {
                  handleAreaChange(val);
                }
              "
              clearable
              filterable
              placeholder="请选择区"
              :disabled="editDisable"
            >
              <el-option
                v-for="item in areaList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="开户支行名"
              prop="accountBranchName"
              :required="true"
            >
              <el-input
                v-model="form.accountBranchName"
                placeholder="请输入"
                :disabled="editDisable"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授权函" :required="true">
              <div>
                <div
                  v-if="form.licenseAuthLetterImage == ''"
                  @click="uploadBtnClick('licenseAuthLetterImage')"
                  size="medium"
                  round
                  class="uploadFile"
                >
                  {{ uploading ? "正在上传..." : "选择文件" }}
                  <i
                    v-if="!uploading"
                    class="el-icon-upload el-icon--right"
                  ></i>
                </div>
                <div v-else>
                  <ul class="file-list">
                    <li class="file-item">
                      <div
                        title="点击查看"
                        style="cursor: pointer"
                        @click="open(form.licenseAuthLetterImage)"
                      >
                        <img
                          :src="
                            ShowImg(
                              licenseAuthLetterImageFile.licenseAuthLetterImageExt
                            )
                          "
                          class="img-icon"
                        />
                        <span>{{
                          licenseAuthLetterImageFile.licenseAuthLetterImageName
                        }}</span>
                      </div>

                      <img
                        v-show="!editDisable"
                        src="../../../../assets/img/del.svg"
                        alt=""
                        class="del"
                        @click="delFile('licenseAuthLetterImage')"
                      />
                    </li>
                  </ul>
                </div>
                <input
                  style="display: none"
                  type="file"
                  single
                  ref="licenseAuthLetterImage"
                  @change="upload"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="main-title line">
          <img src="@/assets/img/payCard/other.jpg" alt="" />
          <p>签约信息</p>
        </div>
        <el-row>
          <el-form-item label="商户签约服务" prop="service" :required="true">
            <el-checkbox-group v-model="form.service" :disabled="editDisable">
              <el-checkbox
                v-for="item in serviceList"
                :label="item.label"
                :key="item.id + item.label"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="开经营所在地" :required="true">
              <el-select
                style="margin-right: 10px"
                v-model="form.businessAddressCode.proviceCode"
                @change="
                  (val) => {
                    handleBusinessProviceChange(val);
                  }
                "
                clearable
                filterable
                placeholder="请选择省"
                :disabled="editDisable"
              >
                <el-option
                  v-for="item in proviceList"
                  :key="item.area_code"
                  :label="item.area_name"
                  :value="item.area_code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-select
              style="margin-right: 10px"
              v-model="form.businessAddressCode.cityCode"
              @change="
                (val) => {
                  handleBusinessCityChange(val);
                }
              "
              clearable
              filterable
              placeholder="请选择市"
              :disabled="editDisable"
            >
              <el-option
                v-for="item in businessCityList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="form.businessAddressCode.areaCode"
              @change="
                (val) => {
                  handleBusinessAreaChange(val);
                }
              "
              clearable
              filterable
              placeholder="请选择区"
              :disabled="editDisable"
            >
              <el-option
                v-for="item in businessAreaList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="详细地址:" prop="address" :required="true">
              <el-input v-model="form.address" placeholder="请输入" :disabled="editDisable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="门头照" :required="true">
              <div class="upload_box" title="查看照片">
                <div
                  class="uploadBtn"
                  v-if="form.outDoorImages == ''"
                  @click="uploadBtnClick('outDoorImages')"
                >
                  <i class="el-icon-plus"></i>
                </div>
                <div class="img_box" v-else>
                  <img
                    class="showImg"
                    @click="see('outDoorImages')"
                    :src="form.outDoorImages"
                    alt=""
                  />
                  <img
                    v-show="!editDisable"
                    class="del"
                    @click="delFile('outDoorImages')"
                    src="../../../../assets/img/del.svg"
                    alt=""
                  />
                </div>
              </div>
              <input
                style="display: none"
                type="file"
                single
                ref="outDoorImages"
                @change="upload"
              />
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="内景照" :required="true">
              <div class="upload_box" title="查看照片">
                <div
                  class="uploadBtn"
                  v-if="form.inDoorImages == ''"
                  @click="uploadBtnClick('inDoorImages')"
                >
                  <i class="el-icon-plus"></i>
                </div>
                <div class="img_box" v-else>
                  <img
                    class="showImg"
                    @click="see('inDoorImages')"
                    :src="form.inDoorImages"
                    alt=""
                  />
                  <img
                    v-show="!editDisable"
                    class="del"
                    @click="delFile('inDoorImages')"
                    src="../../../../assets/img/del.svg"
                    alt=""
                  />
                </div>
              </div>
              <input
                style="display: none"
                type="file"
                single
                ref="inDoorImages"
                @change="upload"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="商户服务类型" prop="siteType" :required="true">
            <!-- <el-checkbox-group v-model="form.siteType">
              <el-checkbox
                v-for="item in siteTypeList"
                :label="item.id"
                :key="item.id + item.label"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group> -->
            <el-radio
              v-for="it in siteTypeList"
              :key="it.value"
              v-model="form.siteType"
              :label="it.value"
              :disabled="editDisable"
            >
              {{ it.label }}
            </el-radio>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="行业资质类型"
            prop="industryQualificationType"
            :required="true"
          >
            <el-select
              style="margin-right: 10px"
              v-model="form.industryQualificationType"
              @change="
                (val) => {
                  handleQualificationsChange(val);
                }
              "
              clearable
              filterable
              placeholder="请选择"
              :disabled="editDisable"
            >
              <el-option
                v-for="item in industryQualificationTypeList"
                :key="item.code"
                :label="item.lable"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="资质证件类型" :required="true">
              <el-input
                disabled
                v-model="form.name"
                placeholder="自动带入无法编辑"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>343
          <el-col :span="12">
            <el-form-item label="资质证件号" :required="true">
              <el-input
                disabled
                v-model="form.name"
                placeholder="自动带入无法编辑"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="行业资质证明" :required="true">
              <div>
                <div
                  v-if="form.industryQualificationImage == ''"
                  @click="uploadBtnClick('industryQualificationImage')"
                  size="medium"
                  round
                  class="uploadFile"
                >
                  {{ uploading ? "正在上传..." : "选择文件" }}
                  <i
                    v-if="!uploading"
                    class="el-icon-upload el-icon--right"
                  ></i>
                </div>
                <div v-else>
                  <ul class="file-list">
                    <li class="file-item">
                      <div
                        title="点击查看"
                        style="cursor: pointer"
                        @click="open(form.industryQualificationImage)"
                      >
                        <img
                          :src="
                            ShowImg(
                              industryQualificationImageFile.industryQualificationImageExt
                            )
                          "
                          class="img-icon"
                        />
                        <span>{{
                          industryQualificationImageFile.industryQualificationImageName
                        }}</span>
                      </div>

                      <img
                        v-show="!editDisable"
                        src="../../../../assets/img/del.svg"
                        alt=""
                        class="del"
                        @click="delFile('industryQualificationImage')"
                      />
                    </li>
                  </ul>
                </div>
                <input
                  style="display: none"
                  type="file"
                  single
                  ref="industryQualificationImage"
                  @change="upload"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="main-title line">
        <div class="btn_box">
          <el-button type="primary" size="" @click="save()">确定</el-button>
          <el-button size="" @click="cancel()">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNextAreaInfo } from "@/api/user/userCenter";
import {
  createALiPayMer,
  getMccCategoryTreeList,
} from "@/api/mechanismApi/curriculum.js";
import util from "@/utils/util.js";
import _ from "lodash";
import UploadService from "@/utils/fileCenter/tencentCloud.upload";
import {
  validatePhone,
  validateEMail,
  validateIdcard,
  validateAccountNumber,
} from "@/utils/validate.js";
export default {
  components: {},
  data() {
    return {
      form: {
        loginPlatformCode: sessionStorage.getItem("loginPlatformCode") || "",
        platformCode: sessionStorage.getItem("platformCode") || "",
        usessionid: sessionStorage.getItem("usessionid") || "",
        orgId: sessionStorage.getItem("orgId") || "",
        externalId:
          sessionStorage.getItem("platformCode") +
            sessionStorage.getItem("orgId") || "",
        bindingAlipayLogonId: "",
        aliasName: "",
        name: "",
        mobile: "",
        mcc: "",
        // defaultSettleType: "",
        // defaultSettleTarget: "",
        accountHolderName: "",
        accountNo: "",
        accountBranchName: "",
        usageType: "",
        accountType: "",
        accountInstName: "",
        accountInstId: "",
        licenseAuthLetterImage: "",
        service: [],
        address: "",
        outDoorImages: "",
        inDoorImages: "",
        siteType: "",
        industryQualificationType: "",
        industryQualificationImage: "",
        bankAddressCode: {
          proviceCode: "",
          proviceName: "",
          cityCode: "",
          cityName: "",
          areaCode: "",
          areaName: "",
        },
        businessAddressCode: {
          proviceCode: "",
          proviceName: "",
          cityCode: "",
          cityName: "",
          areaCode: "",
          areaName: "",
        },
      },
      dialogImageUrl: "",
      dialogVisible: false,
      proviceList: [], //省列表数据
      cityList: [], //市列表数据
      areaList: [], //区列表数据
      businessCityList: [], //市列表数据
      businessAreaList: [], //区列表数据
      uploading: false,
      editDisable:false,
      sqFile: [],
      zmFile: [],
      serviceList: [
        { id: "1", label: "当面付" },
        { id: "2", label: "app支付" },
        { id: "3", label: "wap支付" },
        { id: "4", label: "电脑支付" },
        { id: "5", label: "线上资金预授权" },
        { id: "6", label: "新当面资金授权" },
        { id: "7", label: "商户代扣" },
        { id: "8", label: "小程序支付" },
      ],
      siteTypeList: [
        { value: "01", label: "网站" },
        { value: "02", label: "app" },
        { value: "03", label: "服务站" },
        { value: "04", label: "公众号" },
        { value: "05", label: "其它" },
        { value: "06", label: "支付宝小程序" },
      ],
      industryQualificationTypeList: [
        { lable: "彩票销售许可证	            ", code: "301" },
        { lable: "医疗器械经营许可证	        ", code: "302" },
        { lable: "药品经营许可证	            ", code: "303" },
        { lable: "酒类经营许可证	            ", code: "304" },
        { lable: "酒类销售许可证	            ", code: "305" },
        { lable: "文物经营许可证	            ", code: "306" },
        { lable: "文物销售许可证	            ", code: "307" },
        { lable: "文物复制许可证	            ", code: "308" },
        { lable: "典当经营许可证	            ", code: "309" },
        { lable: "健身器材销售许可证	        ", code: "310" },
        { lable: "健身器材生产许可证	        ", code: "311" },
        { lable: "化妆品经营备案登记证	      ", code: "312" },
        { lable: "化妆品生产企业卫生许可证    ", code: "313" },
        { lable: "化妆品生产许可证	          ", code: "314" },
        { lable: "危险化学品经营许可证	      ", code: "315" },
        { lable: "卫生许可证	                ", code: "316" },
        { lable: "动物诊疗许可证	            ", code: "317" },
        { lable: "动物防疫合格证	            ", code: "318" },
        { lable: "拍卖许可证	                ", code: "319" },
        { lable: "拍卖经验批准证书	          ", code: "320" },
        { lable: "网络文化经营许可证          ", code: "321" },
        { lable: "医疗机构执业许可证          ", code: "322" },
        { lable: "金融许可证	                ", code: "323" },
        { lable: "金融证券业务许可证	        ", code: " 324" },
        { lable: "基金业务相关许可证	        ", code: " 325" },
        { lable: "人力资源服务许可证	        ", code: " 326" },
        { lable: "人力中介服务许可证	        ", code: " 327" },
        { lable: "小额贷款公司经营许可证	    ", code: " 328" },
        { lable: "支付业务许可证	            ", code: " 329" },
        { lable: "融资性担保机构经营许可证    ", code: " 330" },
        { lable: "餐饮服务许可证	            ", code: " 331" },
        { lable: "食品经营许可证	            ", code: " 332" },
        { lable: "食品流通许可证	            ", code: " 333" },
        { lable: "网络文化许可证	            ", code: " 334" },
        { lable: "娱乐场所许可证	            ", code: " 335" },
        { lable: "音像制品许可证	            ", code: " 336" },
        { lable: "机票代理资格证许可证	      ", code: " 337" },
        { lable: "直销业务资质许可证	        ", code: " 338" },
        { lable: "保险业务许可证	            ", code: " 339" },
        { lable: "电信业务许可证	            ", code: " 340" },
        { lable: "食品安全证书	              ", code: " 341" },
        { lable: "保险代理资质	              ", code: " 342" },
        { lable: "消费金融公司资质	          ", code: "  343" },
        { lable: "汽车金融公司资质	          ", code: "  344" },
        { lable: "融资租赁公司资质	          ", code: "  345" },
        { lable: "金融租赁公司资质	          ", code: "  346" },
        { lable: "信托公司资质	              ", code: "  347" },
        { lable: "烟花爆竹经营资质	          ", code: "  348" },
        { lable: "经营流通人民币许可证	      ", code: "  349" },
        { lable: "融资担保公司资质	          ", code: "  350" },
        { lable: "证券投资咨询业务资格证书    ", code: "   352" },
        { lable: "2P资质	                    ", code: "  353" },
        { lable: "网络商业保理资质	          ", code: "   354" },
        { lable: "借贷消费平台资质	          ", code: "   355" },
        { lable: "药品生产许可证	            ", code: "   356" },
        { lable: "牙科执业许可证	            ", code: "   357" },
        { lable: "互联网药品交易服务资格证书  ", code: "   358" },
        { lable: "互联网药品信息服务资格证书  ", code: "   359" },
        { lable: "团餐合作资质	              ", code: "   360" },
        { lable: "心理咨询执业证书	          ", code: "   361" },
        { lable: "司法鉴定资质证书	          ", code: "   362" },
        { lable: "司法鉴定人执业证	          ", code: "   363" },
        { lable: "计算机信息系统安全专用产品销售许可证", code: "  	364" },
        { lable: "烟草资质	                  ", code: "  365" },
        { lable: "运营商合作协议	            ", code: "   366" },
        { lable: "宗教活动场所登记证	        ", code: "   367" },
        { lable: "律师事务所执业许可证	      ", code: "   368" },
        { lable: "物流货运服务资质	          ", code: "   369" },
        { lable: "快递业务资质	              ", code: "   370" },
        { lable: "开锁工具经营许可证	        ", code: "   371" },
        { lable: "办学资质	                  ", code: "   372" },
        { lable: "银行开户许可证	            ", code: "   373" },
        { lable: "加油资质	                  ", code: "   374" },
        { lable: "慈善资质	                  ", code: "   375" },
        { lable: "公共事业缴费资质	          ", code: "   376" },
        { lable: "保险直销资质	              ", code: "   377" },
        { lable: "充电桩资质	                ", code: "   378" },
      ],
      mccOptions: [],
      licenseAuthLetterImageFile: {
        licenseAuthLetterImageExt: "",
        licenseAuthLetterImageName: "",
      },
      industryQualificationImageFile: {
        industryQualificationImageExt: "",
        industryQualificationImageName: "",
      },
      uploadType: "",
      rules: {
        aliasName: [
          { required: true, message: "请输入商户别名", trigger: "blur" },
        ],
        mcc: [{ required: true, message: "请选择商户类别", trigger: "change" }],
        bindingAlipayLogonId: [
          { required: true, message: "请输入签约支付宝账号", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入联系人名称", trigger: "blur" },
        ],
        externalId: [
          { required: true, message: "请输入商户编号", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        accountHolderName: [
          { required: true, message: "请输入账户名", trigger: "blur" },
        ],
        accountInstName: [
          { required: true, message: "请输入银行名称", trigger: "blur" },
        ],
        accountInstId: [
          { required: true, message: "请输入银行缩写", trigger: "blur" },
        ],
        accountType: [
          { required: true, message: "请选择卡类型", trigger: "change" },
        ],
        accountNo: [
          { required: true, message: "请输入开户行号", trigger: "blur" },
          { validator: validateAccountNumber, trigger: "blur" },
        ],
        usageType: [
          { required: true, message: "请选择账号使用类型", trigger: "change" },
        ],
        accountBranchName: [
          { required: true, message: "请输入开户支行名", trigger: "blur" },
        ],
        service: [
          { required: true, message: "请选择商户签约服务", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        siteType: [
          { required: true, message: "请选择商户服务类型", trigger: "change" },
        ],
        industryQualificationType: [
          { required: true, message: "请选择行业资质类型", trigger: "change" },
        ],
      },
    };
  },
  mounted() {},

  created() {
    this.initData();
  },
  methods: {
    initData() {
      console.log("获取跳转的参数", this.$route.query);
      this.editDisable=this.$route.query.type=='see'?true:false
       let _info=this.info
      _info= this.$route.query.info;
      if (_info) {
        for (var k in _info) {
          this.form[k] = _info[k];
        }
         if(typeof this.form.bankAddressCode != 'object'){
          this.form.bankAddressCode={
            proviceCode: "",
            proviceName: "",
            cityCode: "",
            cityName: "",
            areaCode: "",
            areaName: "",
          }
        }
        if(typeof this.form.businessAddressCode != 'object'){
          this.form.businessAddressCode={
            proviceCode: "",
            proviceName: "",
            cityCode: "",
            cityName: "",
            areaCode: "",
            areaName: "",
          }
        }
      }
      // 用户中心获取全部省的数据
      getNextAreaInfo({ area_code: "0" }).then((res) => {
        if (res.code == "000000") {
          this.proviceList = res.result;
        }
      });
      getMccCategoryTreeList().then((res) => {
        if (res.result == "000000") {
          // console.log("获取mcc数据", res.data);
          this.mccOptions = this.filterMccData(res.data);
        }
      });
    },
    filterMccData(data) {
      if (data.length > 0) {
        data.forEach((it) => {
          this.$set(it, "value", it.mcc);
          this.$set(it, "label", it.name);
          if (it.children) {
            this.filterMccData(it.children);
          }
        });
      }
      return data;
    },
    handleMcchange(val) {
      // console.log("handleMcchange", val[2]);
      this.form.mcc = val[2];
    },
    open(url) {
      window.open(url);
    },
    save: _.throttle(
     async function () {
        let _this = this.form;
        if (_this.licenseAuthLetterImage == "") {
          this.$message({
            type: "error",
            message: "请上传授权函",
          });
          return;
        } else if (_this.outDoorImages == "") {
          this.$message({
            type: "error",
            message: "请上传门头照",
          });
          return;
        } else if (_this.inDoorImages == "") {
          this.$message({
            type: "error",
            message: "请上传内景照",
          });
          return;
        } else if (_this.industryQualificationImage == "") {
          this.$message({
            type: "error",
            message: "请上传行业资质证明",
          });
          return;
        } else if (_this.bankAddressCode.proviceCode == "") {
          this.$message({
            type: "error",
            message: "请选择开户行所在地",
          });
          return;
        } else if (_this.businessAddressCode.proviceCode == "") {
          this.$message({
            type: "error",
            message: "请选择开经营所在地",
          });
          return;
        }
        this.$refs["rulesForm"].validate(async (valid) => {
          if (valid) {
            const { result, data, desc } = await createALiPayMer(this.form);
            if (result == "000000") {
              this.$message({
                type: "success",
                message: "开通成功",
              });
              this.$router.go(-1);
              this.resetForm();
              // this.$refs["rulesForm"].resetFields(); //重置表单
            } else {
              this.$message({
                type: "error",
                message: desc,
              });
              // this.saveDisable = false;
            }
          } else {
            this.$message({
              type: "error",
              message: "请输入必填",
            });
          }
        });
      },
      3000,
      { leading: true, trailing: false }
    ),
    cancel() {
      this.$router.go(-1);
    },
    resetForm() {
      let _this = this.form;
      for (let k in _this) {
        this.form[k] = "";
      }
      _this.bankAddressCode = {
        proviceCode: "",
        proviceName: "",
        cityCode: "",
        cityName: "",
        areaCode: "",
        areaName: "",
      };
      _this.businessAddressCode = {
        proviceCode: "",
        proviceName: "",
        cityCode: "",
        cityName: "",
        areaCode: "",
        areaName: "",
      };
    },
    // async uploadHttpRequest(param) {
    //   console.log("---file", param.file);
    //   let sourceFiles = param.file;
    //   this.uploadInstance = new UploadService({
    //     appType: "khfw",
    //     userInfo: {
    //       userId: JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
    //       platformCode: JSON.parse(window.sessionStorage.getItem("Userlist"))
    //         .platformCode,
    //     },
    //   });
    //   let ext = util.getFileExt(sourceFiles["name"]);
    //   if (sourceFiles["size"] == 0) {
    //     //大小为0的文件
    //     this.$message({
    //       message: `文件${sourceFiles["name"]}是空文件,请重新上传`,
    //       type: "error",
    //       duration: 1000,
    //     });
    //     return;
    //   }
    //   this.uploadInstance
    //     .upload(sourceFiles, {
    //       onProgress: (progress) => {},
    //     })
    //     .then((res) => {
    //       console.log("上传完的文件---", res);
    //       if (res.code == "000000") {
    //         let fileObj = {
    //           name: sourceFiles["name"],
    //           size: this.formatFileSize(sourceFiles.size),
    //           fileLength: sourceFiles.size,
    //           type: this.getExt(ext),
    //           ext: ext,
    //           fid: res.data.fid,
    //           downloadUrl: res.data.downloadUrl,
    //           previewUrl: res.data.previewUrl,
    //         };
    //         this.form.headPhoto.push(fileObj);
    //       } else {
    //         this.$message({
    //           message: "上传失败",
    //           type: "error",
    //           duration: 1000,
    //         });
    //       }
    //     });
    // },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploadBtnClick(type) {
      this.uploadType = type;
      this.$refs[type].click();
    },
    async upload(e) {
      this.uploading = true;
      const sourceFiles = this.$refs[this.uploadType].files[0];
      console.log("---sourceFiles", sourceFiles);
      this.uploadInstance = new UploadService({
        appType: "khfw",
        userInfo: {
          userId: JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
          platformCode: JSON.parse(window.sessionStorage.getItem("Userlist"))
            .platformCode,
        },
      });
      let name = sourceFiles["name"];
      let ext = util.getFileExt(sourceFiles["name"]);
      // console.log('打印上传参数---',name,ext,this.uploadType);
      if (this.uploadType == "licenseAuthLetterImage") {
        this.licenseAuthLetterImageFile = {
          licenseAuthLetterImageExt: ext,
          licenseAuthLetterImageName: name,
        };
      } else if (this.uploadType == "industryQualificationImage") {
        this.industryQualificationImageFile = {
          industryQualificationImageExt: ext,
          industryQualificationImageName: name,
        };
      }
      if (sourceFiles["size"] == 0) {
        //大小为0的文件
        this.$message({
          message: `文件${sourceFiles["name"]}是空文件,请重新上传`,
          type: "error",
          duration: 1000,
        });
        return;
      }
      this.uploadInstance
        .upload(sourceFiles, {
          onProgress: (progress) => {},
        })
        .then((res) => {
          if (res.code == "000000") {
            this.uploading = false;
            this.form[this.uploadType] =
              res.data.previewUrl || res.data.downloadUrl;
            this.$forceUpdate();

            console.log("上传完的文件---", this.form[this.uploadType]);
          } else {
            this.$message({
              message: "上传失败",
              type: "error",
              duration: 1000,
            });
          }
          e.target.value = "";
        });
    },
    see(url) {
      this.dialogVisible = true;
      this.dialogImageUrl = this.form[url];
      this.$forceUpdate();
    },
    delFile(type) {
      this.form[type] = "";
      let uploadInput = this.$refs[this.uploadType];
      uploadInput.value = "";
      this.$forceUpdate();
    },

    handleChange1() {},
    handleChange2() {},
    handleChange3() {},
    handleQualificationsChange(val) {
      console.log("类型---", val);
    },
    async handleProviceChange(areaCode) {
      var obj = {};
      obj = this.proviceList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.form.bankAddressCode.proviceName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.cityList = result;
      }
      this.form.bankAddressCode.cityCode = "";
      this.form.bankAddressCode.cityName = "";
      this.form.bankAddressCode.areaCode = "";
      this.form.bankAddressCode.areaName = "";
    },
    async handleCityChange(areaCode) {
      var obj = {};
      obj = this.cityList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.form.bankAddressCode.cityName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.areaList = result;
      }
      this.form.bankAddressCode.areaCode = "";
      this.form.bankAddressCode.areaName = "";
    },
    async handleAreaChange(areaCode) {
      var obj = {};
      obj = this.areaList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.form.bankAddressCode.areaName = obj.area_name;
    },
    async handleBusinessProviceChange(areaCode) {
      var obj = {};
      obj = this.proviceList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.form.businessAddressCode.proviceName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.businessCityList = result;
      }
      this.form.businessAddressCode.cityCode = "";
      this.form.businessAddressCode.cityName = "";
      this.form.businessAddressCode.areaCode = "";
      this.form.businessAddressCode.areaName = "";
    },
    async handleBusinessCityChange(areaCode) {
      var obj = {};
      obj = this.businessCityList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.form.businessAddressCode.cityName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.businessAreaList = result;
      }
      this.form.businessAddressCode.areaCode = "";
      this.form.businessAddressCode.areaName = "";
    },
    async handleBusinessAreaChange(areaCode) {
      var obj = {};
      obj = this.businessAreaList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.form.businessAddressCode.areaName = obj.area_name;
    },
    getExt(ext) {
      return util.getFileType(ext);
    },
    formatFileSize(limit) {
      limit = limit * 1;
      let size = "";
      if (limit < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B";
      } else if (limit < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        // 其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }
      let sizeStr = size + ""; // 转成字符串
      let index = sizeStr.indexOf("."); // 获取小数点处的索引
      let dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
      if (dou === "00") {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0 30px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 20px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}

.main {
  width: 100%;
  height: 100%;
  margin-top: 3%;
  .main-title {
    display: flex;
    align-items: center;
    margin-bottom: 2%;
    .btn_box {
      margin: 2% auto;
    }
    &.line {
      border-top: 1px solid #eaeaea;
      padding-top: 3%;
      margin-top: 3%;
    }
    p {
      font-weight: bold;
      font-size: 14px;
      color: #181c26;
      margin-left: 10px;
    }
  }
  .upload_box {
    width: 148px;
    height: 148px;
    cursor: pointer;
    .el-upload__tip {
      margin-bottom: 10px;
    }
    .uploadBtn {
      width: 100%;
      height: 100%;
      border-radius: 5%;
      background: #fbfdff;
      border: 1px dashed #c0ccda;
    }
    .uploadBtn:hover {
      border: 1px dashed #44a0ff;
    }
    .img_box {
      width: 148px;
      height: 148px;
      position: absolute;
      .showImg {
        width: 148px;
        height: 148px;
        top: 0px;
        left: 0px;
      }
      .del {
        position: relative;
        height: 20px;
        width: 20px;
        cursor: pointer;
        top: -110%;
        left: 85%;
      }
    }
  }
  .uploadFile {
    display: inline-block;
    background: #44a0ff;
    color: #fff;
    text-align: center;
    line-height: 36px;
    border-radius: 3px;
    cursor: pointer;
    height: 36px;
    width: 100px;
  }
  .file-list {
    width: 100%;
    .file-item {
      width: 233px;
      height: 50px;
      line-height: 50px;
      border-radius: 4px;
      background: #f4f9ff;
      position: relative;
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      text-align: center;
      font-size: 14px;
      color: #333;
      div {
        display: flex;
        align-items: center;
        .img-icon {
          margin-left: 10px;
          width: 36px;
          height: 40px;
        }
        span {
          margin-left: 10px;
          width: 300px;
          text-align: left;
          // 省略号
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .del {
        position: absolute;
        top: -3px;
        right: -8px;
        cursor: pointer;
      }
    }
  }
}
.el-icon-plus {
  display: flex;
  justify-content: center;
  text-align: center;
  padding-top: 38%;
  font-size: 30px;
  color: #8c939d;
}
</style>
